import { Skeleton } from '../../../../Skeleton'
import { RequestProfileTabActivitiesSkeletonPhaseHeader } from '../RequestProfileTabActivitiesSkeletonPhaseHeader'
import { RequestProfileTabActivitiesSkeletonPhaseTable } from '../RequestProfileTabActivitiesSkeletonPhaseTable'

import * as styles from '../RequestProfileTabActivitiesSkeleton.module.css'

function RequestProfileTabActivitiesSkeletonPhase({ isExpanded }) {
  return (
    <div className={styles.phase}>
      <RequestProfileTabActivitiesSkeletonPhaseHeader />
      <Skeleton className={styles.progressSkeleton} />
      {isExpanded ? <RequestProfileTabActivitiesSkeletonPhaseTable /> : null}
    </div>
  )
}

export default RequestProfileTabActivitiesSkeletonPhase
